import { render, staticRenderFns } from "./AnimatedCharacters.vue?vue&type=template&id=1486b80c&scoped=true&"
import script from "./AnimatedCharacters.vue?vue&type=script&lang=js&"
export * from "./AnimatedCharacters.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedCharacters.vue?vue&type=style&index=0&id=1486b80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1486b80c",
  null
  
)

export default component.exports